import api from '../../../services/api';

/**
 * Fetch user tasks by status
 * @param {string} status - Task status (waiting, active, completed, failed)
 * @param {number} limit - Maximum number of tasks to fetch
 * @returns {Promise} API response
 */
export const fetchUserTasks = async (status = 'active', limit = 50) => {
  try {
    const response = await api.get(`/queue/user-tasks/${status}`, {
      params: { limit }
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${status} tasks:`, error);
    throw error;
  }
};

/**
 * Fetch user task counts for all statuses
 * @returns {Promise} API response with counts
 */
export const fetchUserTaskCounts = async () => {
  try {
    const response = await api.get('/queue/user-task-counts');
    return response.data;
  } catch (error) {
    console.error('Error fetching task counts:', error);
    throw error;
  }
};

/**
 * Fetch detailed task information by ID
 * @param {string} taskId - Task ID
 * @returns {Promise} API response
 */
export const fetchTaskDetails = async (taskId) => {
  try {
    const response = await api.get(`/queue/task/${taskId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching task ${taskId}:`, error);
    throw error;
  }
};

/**
 * Cancel a task by ID (if supported)
 * @param {string} taskId - Task ID
 * @returns {Promise} API response
 */
export const cancelTask = async (taskId) => {
  try {
    const response = await api.post(`/queue/task/${taskId}/cancel`);
    return response.data;
  } catch (error) {
    console.error(`Error canceling task ${taskId}:`, error);
    throw error;
  }
};

/**
 * Retry a failed task (if supported)
 * @param {string} taskId - Task ID
 * @returns {Promise} API response
 */
export const retryTask = async (taskId) => {
  try {
    const response = await api.post(`/queue/task/${taskId}/retry`);
    return response.data;
  } catch (error) {
    console.error(`Error retrying task ${taskId}:`, error);
    throw error;
  }
};

/**
 * Clear completed tasks for current user
 * @returns {Promise} API response
 */
export const clearCompletedTasks = async () => {
  try {
    const response = await api.delete('/queue/user-tasks/completed');
    return response.data;
  } catch (error) {
    console.error('Error clearing completed tasks:', error);
    throw error;
  }
};

/**
 * Get task statistics for current user
 * @returns {Promise} API response with stats
 */
export const fetchUserTaskStats = async () => {
  try {
    const response = await api.get('/queue/user-task-stats');
    return response.data;
  } catch (error) {
    console.error('Error fetching task stats:', error);
    throw error;
  }
};
